export default __webpack_public_path__ + "static/media/pratham.559b8970.png";